import { makeStyles } from "$components/mui-styles";
import { Typography, type TypographyProps } from "@material-ui/core";
import type { CardColors } from "./types";
import { getCardColor } from "./utils";

export type CardSubtitleProps = {
  color: CardColors;
} & Omit<TypographyProps, "color">;

const useStyles = makeStyles((theme) => ({
  subtitle: ({ color }: { color: CardColors }) => ({
    fontSize: 12,
    color: getCardColor(theme, color),
  }),
}));

const CardSubtitle = ({ children, color, ...props }: CardSubtitleProps) => {
  const classes = useStyles({ color });
  return (
    <Typography className={classes.subtitle} {...props}>
      {children}
    </Typography>
  );
};

export default CardSubtitle;
